import { eEndorsements } from '../../../ui-toolkit/enums/eEndorsements';

const endorsementHumanDictionary = {
  ChangeOfPartners: 'Change of Partners',
  RevolvingCredit: 'Revolving Credit',
  WaiverOfArbitration: 'Waiver of Arbitration',
};

export const humanizeEndorsement = (endorsement: eEndorsements): string => {
  if (endorsementHumanDictionary[endorsement]) return endorsementHumanDictionary[endorsement];
  return endorsement.startsWith('_T_')
    ? endorsement.replace(/^_T_/, ' T-').replace(/_/g, '.')
    : endorsement.replace(/_/g, ' ');
};
